<template>
  <div>
    <table class="table is-fullwidth is-striped" v-if="hasActivityLogEntries">
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>Context</th>
          <th>Action</th>
          <th>Data</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="entry in activityLog" :key="entry.id">
          <td>
            <span>{{ entry.timestamp }}</span>
          </td>
          <td>
            <span>{{ entry.context }}</span>
          </td>
          <td>
            <span>{{ entry.action }}</span>
          </td>
          <td>
            <span>{{ entry.data }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="notification is-warning" v-if="showMoreEntriesAvailableWarning">Only displaying the 200 most recent entries.</div>
  </div>
</template>

<script>
export default {
  name: "ActivityLog",

  components: { },

  props: {
    activityLog: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    hasActivityLogEntries() {
      if (!this.activityLog) {
        return false
      }

      return this.activityLog.length > 0;
    },

    showMoreEntriesAvailableWarning() {
      if (!this.activityLog) {
        return false
      }

      return this.activityLog.length >= 200;
    }
  }
};
</script>

<style lang="scss" scoped>

.tag {
  width: 100%;
}

.table {
  th {
    white-space: nowrap;
  }

  td {
    border-bottom: 0;

    span {
      white-space: nowrap;
    }
  }

  .loader {
    margin-top: 5px;
  }
}

</style>
